import { Box, Typography } from "@mui/material";

interface LegendItemProps {
  text: string;
  children?: React.ReactNode;
  onClick?: () => void;
  sx?: any;
}

const LegendItem = ({ text, children, onClick, sx }: LegendItemProps) => (
  <Box sx={{ display: "flex", alignItems: "center", mt: 1, ...sx }} onClick={onClick}>
    {children}
    <Typography ml={1} variant="caption">{text}</Typography>
  </Box>
);

export default LegendItem;
